import {
  MAXIMUM_FILE_UPLOAD_SIZE,
  MAXIMUM_MAILBOX_FILE_UPLOAD_SIZE,
  MAXIMUM_WHATSAPP_FILE_UPLOAD_SIZE,
  MAXIMUM_WHATSAPP_IMAGE_UPLOAD_SIZE,
  MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL,
  MAXIMUM_LIST_FILE_UPLOAD_SIZE,
} from 'shared/constants/messages';
import { checkFileSizeLimit } from 'shared/helpers/FileHelper';
import { DirectUpload } from 'activestorage';

export default {
  data() {
    return {
      pendingUploadSize: 0,
    };
  },
  methods: {
    fileUploadHandler(file, opts = {}) {
      if (!opts.isMailboxFileUpload) {
        this.onFileUpload(file, opts);
        return;
      }

      const existingSize = (this.attachedFiles || []).reduce(
        (total, attachment) =>
          total +
          (attachment.resource?.size || attachment.resource?.byte_size || 0),
        0
      );
      const newFileSize = file?.file?.size || file?.size || 0;
      const totalSizeInMB =
        (existingSize + this.pendingUploadSize + newFileSize) / (1024 * 1024);
      if (totalSizeInMB > MAXIMUM_LIST_FILE_UPLOAD_SIZE) {
        this.showAlert(
          this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
            MAXIMUM_FILE_UPLOAD_SIZE: MAXIMUM_LIST_FILE_UPLOAD_SIZE,
            MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE: MAXIMUM_LIST_FILE_UPLOAD_SIZE,
          })
        );
        return;
      }
      this.pendingUploadSize += newFileSize;
      this.$nextTick(() => {
        this.pendingUploadSize = 0;
      });
      this.onFileUpload(file, opts);
    },
    onFileUpload(file, opts = {}) {
      const MAX_FILE_SIZE = (() => {
        switch (true) {
          case opts.isMailboxFileUpload:
            return MAXIMUM_MAILBOX_FILE_UPLOAD_SIZE;
          case opts.isWhatsAppFileUpload: {
            const fileType = file?.file?.type || file?.type || '';
            return fileType.startsWith('image/')
              ? MAXIMUM_WHATSAPP_IMAGE_UPLOAD_SIZE
              : MAXIMUM_WHATSAPP_FILE_UPLOAD_SIZE;
          }
          default:
            return MAXIMUM_FILE_UPLOAD_SIZE;
        }
      })();
      if (this.globalConfig.directUploadsEnabled) {
        this.onDirectFileUpload(file, MAX_FILE_SIZE);
      } else {
        this.onIndirectFileUpload(file, MAX_FILE_SIZE);
      }
    },
    onDirectFileUpload(file, MAX_FILE_SIZE = MAXIMUM_FILE_UPLOAD_SIZE) {
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE = this.isATwilioSMSChannel
        ? MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL
        : MAX_FILE_SIZE;

      if (!file) {
        return;
      }
      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        const upload = new DirectUpload(
          file.file,
          `/api/v1/accounts/${this.accountId}/conversations/${this.currentChat.id}/direct_uploads`,
          {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          }
        );

        upload.create((error, blob) => {
          if (error) {
            this.showAlert(error);
          } else {
            this.attachFile({ file, blob });
          }
        });
      } else {
        this.showAlert(
          this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
            MAXIMUM_FILE_UPLOAD_SIZE: MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
            MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE:
              MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
          })
        );
      }
    },
    onIndirectFileUpload(file, MAX_FILE_SIZE = MAXIMUM_FILE_UPLOAD_SIZE) {
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE = this.isATwilioSMSChannel
        ? MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL
        : MAX_FILE_SIZE;
      if (!file) {
        return;
      }
      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        this.attachFile({ file });
      } else {
        this.showAlert(
          this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
            MAXIMUM_FILE_UPLOAD_SIZE: MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
            MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE:
              MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
          })
        );
      }
    },
  },
};
